<template>
  <div>
    <div class="crm-main-bg">
      <div class="crm-main-logo">
        <img
          class="crm-main-logo-img"
          :src="`${this.crm_public_path}${restaurantInfo.logoImgKey}`"
        />
        <div class="crm-main-name px-4" @click="onClickSwitchBranch">
          <p class="crm-restaurant-name text-1-line ma-0">
            {{ restaurantInfo.restaurantName }}
          </p>
          <div style="max-width: calc(100% - 20px);">
            <div class="d-flex buble-crm-name mt-3">
              <span class="crm-branch-name text-1-line ma-0">
              {{ $t('components.home.branches') }} {{ branchInfo.branchName }}
              </span>
              <svg-arrow-down-circle class="crm-arrow-down-circle ml-2" />
            </div>
          </div>
        </div>
        <div class="crm-online-order"  :style="branchInfo.receiveOrderFlag == 0 && 'visibility: hidden;'">
          <div class="crm-wrap-flex-center">
            <a :href="`${online_order_path}${restaurantUUID}/${branchUUID}`" target="_blank">
              <img class="ma-0" :src="require(`@/assets/svg/bag.svg?inline`)" />
              <label class="ml-2 mt-1">{{ $t('components.home.order-food') }}</label>
            </a>
          </div>
        </div>
      </div>
      <el-card
        v-if="userInfo"
        shadow="alway"
        class="card-box"
        :style="{bottom: !userInfo.ranking? '-40px':'-120px'}"
        :body-style="{ padding: '0px' }"
        @click.native="!userInfo.ranking?toRouteName('History'):toRouteName('TierDetail')"
      >
        <el-row class="crm-container-card">
          <el-col :span="14">
            <p class="crm-point-text text-1-line ma-0">{{ userInfo.name }}</p>
            <img width="15" :src="require(`@/assets/svg/phone-icon.svg?inline`)" alt="telephone icon"/>
            <label class="crm-phone-text pl-2">{{
              userInfo.phoneNumber | formatPhoneNumber
            }}</label>
          </el-col>
          <el-col :span="10" class="crm-main-points">
            <points class="mr-3" />&nbsp;
            <label class="crm-number-point">{{
              numberWithCommas(userInfo.point == "" ? 0 : userInfo.point)
            }}</label>
            <label class="crm-text-point">{{ $t('components.history.point') }}</label>
          </el-col>
        </el-row>
        <el-row v-if="userInfo.ranking" class="membership-tier-info-card">
          <el-col :span="24">
            <el-progress :stroke-width="8" :color="colorProgress" :percentage="calPercentTier(userInfo.ranking)" :show-text="false"></el-progress>
          </el-col>
          <el-col :span="24" class="d-flex-between mt-3">
            <div v-if="userInfo.ranking.isMax" class="d-grid text-suggest-tier">
              <span class="scroll-x">{{$t('membership-tier.tier-max')}}</span>
            </div>
            <div v-else class="d-grid text-suggest-tier">
              <span class="scroll-x">{{$t('membership-tier.tier-more')}} {{numberWithCommas(userInfo.ranking.valueDiff)}} {{convertUnit(userInfo.ranking.accumulationType)}} {{$t('membership-tier.tier-for-unlock')}} {{userInfo.ranking.nextNameTier}}</span>
              <span v-if="userInfo.ranking.tierRenewalDT != null">
                {{$t('membership-tier.max-date')}} {{ moment(userInfo.ranking.tierRenewalDT).format('DD/MM/YYYY') }}
              </span>
            </div>
            <BackgroundTier
              :tierName="userInfo.ranking.name" 
              :colorBase="userInfo.ranking.iconTheme.bgColor" 
              :colorOutline="userInfo.ranking.iconTheme.bgOutline" 
              :colorInline="userInfo.ranking.iconTheme.bgInline" 
              :image="userInfo.ranking.iconTheme.iconKey"/>
          </el-col>
        </el-row>
      </el-card>
    </div>
    <home-header
      :restaurantName="restaurantInfo.restaurantName"
      :branchName="branchInfo.branchName"
      :logo="`${this.crm_public_path}${restaurantInfo.logoImgKey}`"
      :points="userInfo.point"
      :showWhen="145"
      @clickOnPoints="toRouteName('History')"
      @clickOnSwitchBranch="onClickSwitchBranch"
    />
    <slot />
    <main-footer />
    <branch-list
      :visible="showDrawerSwitchBranch"
      @onCloseDrawerSwitchBranch="onCloseDrawerSwitchBranch"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import mixins from "@/helper/mixins";
import MainFooter from "@/components/MainFooter";
import Points from "@/components/icons/Points.vue";
import BackgroundTier from "@/components/icons/BackgroundTier.vue";
import HomeHeader from "@/components/parallax/HomeHeader.vue";
const BranchList = () => import("@/components/home/BranchList.vue");
const SvgArrowDownCircle = () => import("@/assets/svg/arrow-down-circle.svg");
import GATracking from "@/helper/GATrackingMixins";
import moment from "moment";

export default {
  components: {
    MainFooter,
    Points,
    BackgroundTier,
    SvgArrowDownCircle,
    BranchList,
    HomeHeader,
  },
  mixins: [mixins, GATracking],
  data() {
    return {
      crm_public_path: process.env.VUE_APP_S3_PUBLIC_PATH,
      online_order_path: process.env.VUE_APP_ONLINE_ORDER,
      points: 0,
      showDrawerSwitchBranch: false,
      colorProgress: 'var(--secondary)',
      moment
    };
  },
  computed: {
    ...mapGetters({
      restaurantInfo: "restaurant/restaurantInfo",
      restaurantUUID: "restaurant/restaurantUUID",
      branchInfo: "branch/branchInfo",
      branchUUID: "branch/branchUUID",
      userInfo: "user/userInfo",
    }),
  },
  async mounted() {
    if(!this.userInfo){
      this.$router.push({ name: 'Login' });
    }
  },
  methods: {
    toRouteName(name) {
      this.trackActivity(11, 'CRMPromotionList');
      if (this.$route.name !== name) this.$router.push({ name: name });
    },
    onClickSwitchBranch() {
      this.trackActivity(3, 'CRMPromotionList');
      this.showDrawerSwitchBranch = true;
    },
    onCloseDrawerSwitchBranch() {
      this.showDrawerSwitchBranch = false;
    },
  },
};
</script>

<style scoped>
.crm-main-bg {
  background-image: url("../../assets/svg/background.svg?inline");
  background-repeat: no-repeat;
  background-color: var(--primary);
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  height: 168px;
  position: relative;
}

.crm-main-logo {
  padding-top: 35px;
  font-weight: bold;
  font-size: 24px;
  line-height: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #ffffff;
}

.crm-main-name {
  width: calc(100% - 190px);
  box-sizing: border-box;
}

.crm-wrap-flex-center {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.membership-tier-info-card {
  padding: 0 16px 24px;
}

.btn-tier {
  border-radius: 24px;
  height: 24px;
  padding: 0 10px;
  background: #FBBB58;
  overflow: hidden;
  position: relative;
}

.bg-tier {
  position: absolute;
    background: linear-gradient(294.73deg, #F5E760 32%, #FF8F50 96.05%);
    width: 3.125rem;
    height: 3.125rem;
    border-radius: 100%;
    top: 0;
}

.text-suggest-tier {
  font-size: 18px;
  line-height: 24px;
  color: #828282;
}

.d-grid {
  display: grid;
}

.crm-wrap-flex-center a {
  text-decoration: none;
  color: #fefefe;
  display: contents;
}

.crm-online-order {
  margin-left: auto;
  width: 100px;
  min-width: 80px;
  height: 36px;
  top: 52px;
  background: var(--online-order);
  box-shadow: 0px 2px 5px rgb(0 0 0 / 12%);
  border-radius: 20px 0px 0px 20px;
  right: 0;
}

.crm-online-order label {
  margin-top: 9px;
  font-size: 18px;
  font-weight: 400;
}

.crm-online-order img {
  margin-top: 5px;
  font-size: 18px;
  font-weight: 400;
  margin-right: 5px;
}

.crm-main-logo-img {
  text-align: center;
  border: 1px solid #ffffff;
  border-radius: 50%;
  margin-left: 28px;
  /* margin-right: 19px; */
  width: 60px;
  height: 60px;
}

.card-box {
  z-index: 1;
  background-color: #ffffff;
  background-size: 100% 100%;
  position: absolute;
  width: calc(100% - 54px);
  left: 27px;
  border: none;
  border-radius: 12px;
  box-shadow: 0px 2px 5px rgb(0 0 0 / 12%);
}

.crm-container-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
}

.d-flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.crm-point-text {
  font-weight: thin;
  font-size: 24px;
  line-height: 35px;
  color: #333333;
}

.crm-phone-text {
  font-weight: lighter;
  font-size: 20px;
  color: #828282;
}

.icon-star-point {
  padding-top: 5px;
  margin-right: 8px;
  font-size: 22px;
}

.point-number {
  font-weight: bold;
  font-size: 40px;
  line-height: 16px;
  color: #333333;
  margin-right: 5px;
}

.crm-branch-name {
  max-width: calc(100% - 20px);
  font-size: 14px;
  font-weight: lighter;
  line-height: 16px;
}

.crm-restaurant-name {
  font-size: 24px;
  font-weight: 500;
  line-height: 16px;
}

.crm-main-points {
  display: flex;
  justify-content: flex-end;
}

.crm-main-points img {
  margin-top: -2px;
  margin-right: 4px;
}

.crm-text-point {
  font-weight: lighter;
  font-size: 18px;
  /* line-height: 35px; */
  color: #333333;
  position: absolute;
  margin-top: 20px;
}

.crm-number-point {
  font-size: 32px;
  font-weight: 600;
  margin-top: -10px;
  /* line-height: 35px; */
}

/* .crm-arrow-down-circle {
  position: absolute;
} */

.crm-branch-items {
  margin-block: 12px;
}
.buble-crm-name{
  background: rgba(255, 255, 255, 0.4);
  border-radius: 39px;
  padding: 4px 8px;
  width: min-content;
  max-width: calc(100% - 20px);
}
</style>